const SETTINGS_PAGE_MUTUAL = {
  // Menu
  MENU_GENERAL_SETTINGS: 'General',
  BASE_SETTINGS: 'Base Settings',
  MENU_WIDGET_CUSTOMIZE: 'Widget Customization',
  MENU_OFFICE_HOURS: 'Office hours',
  MENU_EMAIL: 'Email',
  MENU_AUTO_MSG: 'Auto Message',
  MENU_RESPONSE_DELAY: 'Waiting Mode',
  MENU_FORM_GENERATOR: 'Form Generator',
  MENU_RESPONSIVE_ROBOT: 'Responsive Robot',

  // offline form
  WIDGET_FORM_FORCE_OPTION: 'It is necessary to receive information',
  WIDGET_FORM_BEFORE_FIRST_MSG: 'Submit the form before sending the message',
  WIDGET_FORM_OPTIONS_EMAIL: 'Get Email',
  WIDGET_FORM_OPTIONS_PHONE: 'Get Phone number',
  WIDGET_FORM_OPTIONS_EMAIL_PHONE: 'Get Email and Phone number',
  WIDGET_FORM_OPTIONS_NAME_PHONE: 'Get Name and Phone number',
  WIDGET_FORM_OPTIONS_NAME_PHONE_EMAIL: 'Get Email,Name and Phone number',

  WIDGET_FORM_TAB_FORM: 'Form',
  WIDGET_FORM_TAB_MSG: 'Message',
  WIDGET_FORM_SEND_MSG_OPTION:
    'Message sent while getting information from user',

  // Save bar
  SAVE_BAR_SAVE_BTN: 'Save',
  SAVE_BAR_CANCEL_BTN: 'Cancel',

  // Tooltip
  COMING_SOON: 'Coming Soon',

  // FORM GENERATOR
  FORM_GENERATOR_INPUT_TYPE_STRING: 'Text',
  FORM_GENERATOR_INPUT_TYPE_NUMBER: 'Number',
  FORM_GENERATOR_INPUT_TYPE_PHONE: 'Phone Number',
  FORM_GENERATOR_INPUT_TYPE_EMAIL: 'Email',
  FORM_GENERATOR_INPUT_TYPE_NAME: 'Name',
  FORM_GENERATOR_TITLE: 'Form Generator',
  FORM_GENERATOR_FIELD_LABEL: 'Field Number ',
  FORM_GENERATOR_LABEL: 'Specify the field label',
  FORM_GENERATOR_PLACEHOLDER: 'Enter the field name!',
  FORM_GENERATOR_TYPE: 'Determine the field type',
  FORM_GENERATOR_BUTTON: 'Add Form',
  FORM_GENERATOR_ADD_BTN: 'Add a new field',

  //
  FORM_SUBMIT: 'Submit',
};

export default SETTINGS_PAGE_MUTUAL;
